"use strict";function sanitizePhone(e){return(e||"").toString().replace(/[^0-9]/gi,"")}Object.defineProperty(exports,"__esModule",{value:!0}),exports.sanitizePhone=sanitizePhone;
//# sourceMappingURL=sanitize.js.map
